<template>
	<div v-parallax-fit="parallax" class="painting">
		<img src="/themes/rise-theme/dist/images/estate/character-view/holly/05_Book04.png" alt="">
	</div>
</template>

<script>
	export default {
		data() {
			return {
				parallax: [
					{
						start: 0,
						end: 400,
						fromStyle: { transform: 'translateX(-60%) translateY(-40%)', opacity: 0 },
           				toStyle: { transform: 'translateX(-60%) translateY(-40%)', opacity: 1 },
						easing: 'linear'
					},
					{
						start: 800,
						end: 1200,
						fromStyle: { transform: 'translateX(-60%) translateY(-40%) rotateZ(25deg)' },
           				toStyle: { transform: 'translateX(35%) translateY(-100%) rotateZ(25deg)' },
						easing: 'linear'
					},
					{
						start: 1200,
						end: 1800,
						fromStyle: { transform: 'translateX(35%) translateY(-100%) rotateZ(25deg)' },
           				toStyle: { transform: 'translateX(110%) translateY(-205%) rotateZ(25deg)' },
						easing: 'linear'
					},
					{
						start: 1800,
						end: 2200,
						fromStyle: { transform: 'translateX(110%) translateY(-205%) rotateZ(25deg)', opacity: 1 },
           				toStyle: { transform: 'translateX(150%) translateY(-250%) rotateZ(25deg)', opacity: 0.5 },
						easing: 'linear'
					},
					{
						start: 2200,
						end: 2600,
						fromStyle: { transform: 'translateX(150%) translateY(-250%) rotateZ(25deg)', opacity: 0.5 },
           				toStyle: { transform: 'translateX(250%) translateY(-300%) rotateZ(25deg)', opacity: 0 },
						easing: 'linear'
					}
				]
			}
		}
	}
</script>

<style lang="scss" scoped>
	.painting {
		position: absolute;
		top: 50%;
		left: 50%;
		z-index: 1;
		max-width: 200px;
		transition: all 0.1s linear;
	}

	@media screen and (max-width: 1024px) {
        .painting {
            max-width: 120px;
        }
    }

    @media screen and (max-width: 650px) {
        .painting {
            max-width: 75px;
        }
    }
</style>